import { render, staticRenderFns } from "./techTechnologies.vue?vue&type=template&id=851c8fdc&scoped=true&"
import script from "./techTechnologies.vue?vue&type=script&lang=js&"
export * from "./techTechnologies.vue?vue&type=script&lang=js&"
import style0 from "./techTechnologies.vue?vue&type=style&index=0&id=851c8fdc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "851c8fdc",
  null
  
)

export default component.exports